export default __webpack_public_path__ + "static/media/aficacupnations.826bad18.png";